<!-- 回收商家券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList":["2KNTYVWC"],
                "traderId": 1,
                "beginTime": "20210608000000",
                "endTime": "20210608235959",
                "needCouponPark": 0,
                "needCouponStatus": 0,
                "pageNum":"1",
                "pageSize":"10"
                },
            responseCode: {
                "data": {
                    "recordList": [
                        {
                            "carCode": "川A0402领",
                            "code": "test",
                            "couponTypeStr": "时间券",
                            "faceValue": "100",
                            "grantTime": "20210608104815",
                            "grantUserName": "fy",
                            "parkList": [
                                {
                                    "parkCode": "2342LKM",
                                    "parkName": "开发测试车场"
                                }
                            ],
                            "sellBillId": 5274,
                            "serialNumber": "BWQMJ1O4S3R27FK",
                            "status": 0,
                            "traderName": "fy",
                            "validTo": "20210609104815"
                        }
                    ],
                    "total": 1
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            }
,
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询商家列表",
                t_url: this.commonUrls.test+"getTraderCouponGrantRecordList",
                p_url: this.commonUrls.prod+"getTraderCouponGrantRecordList",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编号列表' },
                        { info1: 'traderId', info2: '是', info3: 'Long', info4: '商家ID' },
                        { info1: 'beginTime', info2: '是', info3: 'String', info4: '发放起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '发放结束时间，yyyyMMddHHmmss' },
                        { info1: 'needCouponPark', info2: '否', info3: 'Integer', info4: '是否需要券适用车场：0否；1是；默认0' },
                        { info1: 'needCouponStatus', info2: '否', info3: 'Integer', info4: '是否需要券状态：0否；1是；默认0' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多100条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'code', info2: '是', info3: 'String', info4: '商家券模板代码' },
                        { info1: 'serialNumber', info2: '是', info3: 'String', info4: '券的唯一编号' },
                        { info1: 'traderName', info2: '是', info3: 'String', info4: '商家名称' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'grantUserName', info2: '是', info3: 'String', info4: '发放员名称' },
                        { info1: 'couponTypeStr', info2: '是', info3: 'String', info4: '券类型名称' },
                        { info1: 'couponType', info2: '是', info3: 'String', info4: '券类型（0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算）' },
                        { info1: 'faceValue', info2: '是', info3: 'Decimal', info4: '券面值（金额券单位：元，如：1 表示1元；折扣填0~1,时间券单位：分钟， 如：1 表示1分钟）' },
                        { info1: 'sellBillId', info2: '是', info3: 'Long', info4: '销售ID' },
                        { info1: 'grantTime', info2: '是', info3: 'String', info4: '发放时间，yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '有效期至，yyyyMMddHHmmss' },
                        { info1: 'parkList', info2: '否', info3: 'JSONArray', info4: '适用车场列表' },
                        { info1: 'status', info2: '否', info3: 'Integer', info4: '券状态：0未使用，1已使用，2已回收' },
                        { info1: 'thirdBillCode', info2: '否', info3: 'String', info4: '第三方交易流水号' },                        
                        ]
                },{
                    titleName: 'parkList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/getTraderCouponGrantRecordList.vue